import { render } from "./PartnerItem.vue?vue&type=template&id=4a692b32&scoped=true"
import script from "./PartnerItem.vue?vue&type=script&lang=js"
export * from "./PartnerItem.vue?vue&type=script&lang=js"

import "./PartnerItem.vue?vue&type=style&index=0&id=4a692b32&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a692b32"]])

export default __exports__